import { t, use } from 'i18next';
import { useState, useMemo, useEffect, useRef } from 'react';
import { Menu, Dropdown, Input } from 'antd';
import cx from 'classnames';
import './index.scss';
import {  DownOutlined, SearchOutlined } from '@ant-design/icons';
import { CloseCircleFilledIcon, ChevronDownIcon } from 'tdesign-icons-react';

interface Props {
  sideTabData: {
    type: 'gender' | 'age' | 'timbreLanguage' | 'paymentType' | 'timbreStyle' | 'source' | 'platform';
    value: {
      code: string | number;
      name: string;
      value: string | number;
    }[];
    defaultcode: string | number;
  };
  handleSideVal: (code: number | string, data: string) => void;
  showLabel?: boolean; // lable位置直接显示选中值
  handleHover?: (id: any, flag: boolean) => void;
  id?: any;
  className?: string;
  simple?: boolean;
  needDisable?: boolean;
  triggerDisable?: boolean;
}

const Filter = (props: Props) => {
  const {
    sideTabData,
    handleSideVal,
    showLabel,
    handleHover,
    id,
    className,
    simple,
    needDisable = false,
    triggerDisable = false,
  } = props;
  const lableMapping = {
    gender: t('性别'),
    age: t('年龄'),
    timbreLanguage: t('语种'),
    paymentType: t('三方来源'),
    timbreStyle: t('音色风格'),
    source: t('导入方'),
    platform: t('定制类型'),
  };
  const popupContainerRef = useRef(null);
  const [selectValue, setSelectValue] = useState<number | string>('');
  const [selectCode, setSelectCode] = useState();
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [filteredData, setFilteredData] = useState(sideTabData.value);
  const [searchValue, setSearchValue] = useState('');
  let label: string | number = lableMapping[sideTabData.type];
  useEffect(() => {
    setSelectValue(sideTabData.defaultcode || '');
  }, [sideTabData.defaultcode]);
  if (showLabel) {
    label = selectCode !== 0 && selectCode !== '' ? selectValue : lableMapping[sideTabData.type];
  }

  const overlayStyle = {
    padding: '0',
    borderRadius: '3px',
    boxShadow: ' 0px 4px 8px rgba(0, 0, 0, 0.1)',
    zIndex: '7000',
    pointerEvents: 'none' as const,
  };

  const menuStyle = {
    backgroundColor: '#fff',
    pointerEvents: 'auto' as const,
  };

  const commonData = useMemo(() => {
    return sideTabData;
  }, [sideTabData]);

  const selectMenu = (item: any) => {
    setSelectValue(item.name);
    setSelectCode(item.code);
    handleSideVal(item.code, sideTabData.type);
  };

  const clickMenuItem = (item: any) => {
    selectMenu(item);
    setOpen(false);
    setVisible(false);
  };

  const onSearch = (value: string) => {
    if (!value) {
      setFilteredData(sideTabData.value);
      setIsSearch(false);
      return;
    }
    const filtered = sideTabData.value.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()));
    setFilteredData(filtered);
    setIsSearch(true);
  };

  const menu = (
    <>
      <Menu className="menu_filter" style={{ maxHeight: '230px', overflowY: 'auto', ...menuStyle }} theme="light">
        {sideTabData.type === 'timbreLanguage' && (
          <Menu.Item key={-1} style={{ padding: '0', height: '40px', backgroundColor: '#fff' }}>
            <Input
              suffix={
                <SearchOutlined
                  onClick={() => {
                    onSearch(searchValue);
                  }}
                />
              }
              allowClear={{
                clearIcon: (
                  <CloseCircleFilledIcon
                    onClick={() => {
                      onSearch('');
                    }}
                  />
                ),
              }}
              placeholder={t('搜索')}
              onPressEnter={() => {
                onSearch(searchValue);
              }}
              onChange={(e) => {
                setSearchValue(e.target.value);
                if (!e.target.value) {
                  onSearch('');
                }
              }}
            />
          </Menu.Item>
        )}
        {filteredData.length > 0 ? (
          <>
            {filteredData.map((item, index) => (
              <Menu.Item
                key={item.code}
                className={`
              menu_filter_items
              ${item.name === selectValue ? 'menu_filter_items_active' : ''}
            `}
                onClick={(e) => {
                  e.domEvent.stopPropagation();
                  if (item.name === selectValue) return;
                  clickMenuItem(item);
                  setTimeout(() => {
                    handleHover && handleHover(id, false);
                  }, 300);
                }}
                // disabled={item.name === selectValue || (needDisable && item.disabled)}
              >
                <span className="menu_filter_items_text">{item.name}</span>
              </Menu.Item>
            ))}
          </>
        ) : (
          <div style={{ cursor: 'default', textAlign: 'center', padding: '10px', minWidth: '255px' }}>
            {t('暂无内容')}
          </div>
        )}
      </Menu>
    </>
  );
  const hasMoreStyles = sideTabData?.value?.length > 1;

  return hasMoreStyles ? (
    <div>
      <div ref={popupContainerRef}></div>
      <Dropdown
        trigger={['click']}
        visible={visible}
        onVisibleChange={(flag) => {
          if (triggerDisable) return;
          setVisible(flag);
          handleHover && handleHover(id, flag);
        }}
        overlay={menu}
        overlayStyle={overlayStyle}
        getPopupContainer={() => popupContainerRef.current!}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            padding: '6px 12px',
          }}
        >
          <span className={cx('dropdown', className)} style={{ margin: '0 4px 0 8px' }}>
            {selectCode ? selectValue : label}
          </span>
          <ChevronDownIcon className="icon_arrow" style={{ marginBottom: '0.5px' }} />
        </div>
      </Dropdown>
    </div>
  ) : (
    <span className={cx('dropdown', className)} style={{ cursor: 'default', margin: '0 4px 0 8px' }}>
      {selectCode ? selectValue : label}
    </span>
  );
};

export default Filter;
